import { NewCustomerButton, PageHeader, PortfolioModule } from '@korint/folio';

export function Portfolio() {
  return (
    <div>
      <PageHeader title="Portefeuille" right={<NewCustomerButton />} />
      <PortfolioModule />
    </div>
  );
}
